import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';

import Titulo from '../../components/Texto/Titulo';
import Loading from '../../components/Loading';
import Pesquisa from '../../components/Inputs/Pesquisa';
import * as actions from '../../actions/entregadores';

class Entregadores extends Component {

	state = {
		refreshing: false,
		pesquisaNome: '',
		filtroAtivo: 'todos',
	}

	componentDidMount(){
		const { usuario } = this.props;
		if(usuario && usuario.loja) this.props.getEntregadores(usuario.loja);
	}

	componentDidUpdate(prevProps){
		if(!prevProps.usuario && this.props.usuario){
			this.props.getEntregadores(this.props.usuario.loja);
		}
	}

	_ehErroAction = (data) => {
		if(!data) return true;
		if(data.status && data.message){
			window.alert(data.message);
			return true;
		}
		if(data.error){
			window.alert(typeof data.error === 'string' ? data.error : 'Erro ao processar.');
			return true;
		}
		return false;
	}

	desativar = (row) => {
		if(!window.confirm(`Desativar o entregador "${row.nome}"?`)) return;
		const { usuario } = this.props;
		this.props.desativarEntregador(usuario.loja, row._id)
			.then((data) => {
				if(this._ehErroAction(data)) return;
			});
	}

	refreshList = () => {
		const { usuario } = this.props;
		if(!usuario) return;
		this.setState({ refreshing: true });
		this.props.getEntregadores(usuario.loja);
		const timer = setTimeout(() => {
			this.setState({ refreshing: false });
			clearTimeout(timer);
		}, 1800);
	}

	onChangePesquisaNome = (ev) => this.setState({ pesquisaNome: ev.target.value });

	onFiltroAtivoChange = (ev) => this.setState({ filtroAtivo: ev.target.value });

	limparFiltros = () => this.setState({ pesquisaNome: '', filtroAtivo: 'todos' });

	filtrarEntregadores = (rows) => {
		const { pesquisaNome, filtroAtivo } = this.state;
		const termo = pesquisaNome.trim().toLowerCase();
		return rows.filter((row) => {
			if(filtroAtivo === 'ativos' && !row.ativo) return false;
			if(filtroAtivo === 'inativos' && row.ativo) return false;
			if(termo && !String(row.nome || '').toLowerCase().includes(termo)) return false;
			return true;
		});
	}

	render(){
		const { usuario, lista } = this.props;
		const { refreshing, pesquisaNome, filtroAtivo } = this.state;

		if(!usuario) return <Loading />;

		const rows = Array.isArray(lista) ? lista : [];
		const rowsFiltrados = this.filtrarEntregadores(rows);
		const filtrosAtivos = Boolean(pesquisaNome.trim()) || filtroAtivo !== 'todos';

		return (
			<div className="Categories container-centered EntregadoresPage">
				<div className="Page-Title">
					<Titulo tipo="h1" titulo="Entregadores"/>
					<div className="actionsTollBar">
						<Link to="/entregas" className="entregadoresPage-linkEntregas">Ir às entregas</Link>
						<Link to="/entregadores/importar" className="entregadoresPage-importar">Importar em lote</Link>
						<Link to="/entregadores/novo" title="Novo entregador">
							<div className="btnIcon plus" style={{ marginLeft: 0 }}></div>
						</Link>
					</div>
				</div>

				<div className="entregadoresToolbar">
					<div className="entregadoresToolbarTop">
						<div className="entregadoresToolbarSearchWrap">
							<Pesquisa
								valor={pesquisaNome}
								style={{ margin: 0 }}
								placeholder="Buscar por nome"
								onChange={this.onChangePesquisaNome}
								onClick={() => {}}
							/>
						</div>
					</div>
					<div className="entregadoresFiltersDrawer">
						<div className="entregasFiltersExtrasItems">
							<label className="entregasFiltersPanel-field">
								<span>Status</span>
								<select value={filtroAtivo} onChange={this.onFiltroAtivoChange}>
									<option value="todos">Todos</option>
									<option value="ativos">Ativos</option>
									<option value="inativos">Inativos</option>
								</select>
							</label>
						</div>
						{filtrosAtivos && (
							<div className="entregadoresFiltersDrawer-footer">
								<button type="button" className="entregasLimparFiltrosBtn" onClick={this.limparFiltros}>
									Limpar filtros
								</button>
							</div>
						)}
					</div>
				</div>

				<div className={`Table Entregadores${refreshing ? ' refreshing' : ''}`}>
					<div className="head">
						<div>Nome</div>
						<div>WhatsApp</div>
						<div>Ativo</div>
						<div>Ações</div>
						<button type="button" className="refreshButton" onClick={this.refreshList}>
							<i className="fas fa-redo"></i>
						</button>
					</div>
					<div className="body">
						{ rows.length === 0 ? (
							<div className="item entregadoresTable-empty">
								<span>Nenhum entregador cadastrado.</span>
							</div>
						) : rowsFiltrados.length === 0 ? (
							<div className="item entregadoresTable-empty">
								<span>Nenhum entregador encontrado com os filtros aplicados.</span>
							</div>
						) : rowsFiltrados.map((row) => (
							<div key={row._id} className="item">
								<span>{row.nome}</span>
								<span>{row.telefoneWhatsApp}</span>
								<span>{row.ativo ? 'Sim' : 'Não'}</span>
								<span className="entregadoresTable-actions">
									<Link className="entregadoresTable-linkEdit" to={`/entregadores/${row._id}/edit`}>Editar</Link>
									{ row.ativo && (
										<button type="button" className="danger" onClick={() => this.desativar(row)}>Desativar</button>
									) }
								</span>
							</div>
						)) }
					</div>
				</div>
			</div>
		);
	}
}

const mapStateToProps = state => ({
	usuario: state.auth.usuario,
	lista: state.entregador.lista,
});

export default connect(mapStateToProps, actions)(Entregadores);
